import { useState, type FormEvent } from "react";
import { login } from "../api/client";

interface LoginScreenProps {
  onSuccess: () => void;
}

export function LoginScreen({ onSuccess }: LoginScreenProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!password || submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await login(password);
      onSuccess();
    } catch {
      setError("Nesprávne heslo. Skús to znova.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="screen login-screen">
      <div className="login-card">
        <div className="login-title">J.A.R.V.I.S</div>
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            className="login-input"
            type="password"
            inputMode="text"
            autoComplete="current-password"
            placeholder="Prístupové heslo"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoFocus
          />
          <div className="login-error">{error}</div>
          <button className="login-button" type="submit" disabled={submitting || !password}>
            {submitting ? "Overujem…" : "Vstúpiť"}
          </button>
        </form>
      </div>
    </div>
  );
}
